import {
  Avatar,
  Backdrop,
  Box,
  Button,
  List,
  ListItem,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import styles from "../../styles/pages/editors.module.scss";
import assest from "../../json/assest";
import EditorsLargeModal from "../../ui/Modal/EditorsLargeModal";
import VideoIcon from "../../ui/Icons/VideoIcon";
import AnalyticsIcon from "../../ui/Icons/AnalyticsIcon";
import ProfileIcon from "../../ui/Icons/ProfileIcon";
import VideosummaryCard from "../VideosummaryCard/VideosummaryCard";
import CopywritersModalTable from "../CopywritersModalTable/CopywritersModalTable";
import EditorsCopywritersProfileTab from "../EditorsCopywritersProfileTab/EditorsCopywritersProfileTab";
import RoundCheckIcon from "../../ui/Icons/RoundCheckIcon";

import NOprofileImage from "../../public/assets/images/no-image.svg";

import RoundTickIcon from "../../ui/Icons/RoundTickIcon";
import ModaltableHeader from "../ModaltableHeader/ModaltableHeader";
import InfomarkIcon from "../../ui/Icons/InfomarkIcon";
import WebsiteIcon from "../../ui/Icons/WebsiteIcon";
import { CopyWVIDEOMutation } from "../../api/functions/copywriters.api";
import { useMutation, useQuery } from "react-query";
import { submissionsList } from "../../api/functions/cms.api";
import { concatHostAndImagePath } from "../../lib/functions/utils.lib";
import moment from "moment";
import NotificationLeftFilter from "../NotificationLeftFilter/NotificationLeftFilter";
import { getManagerCardSubmission } from "../../api/functions/manager.api";
import EditorFilter from "../AllFilterRow/SubmittedPageFilter/EditorFilter";
import CopyWrittersFilter from "../AllFilterRow/SubmittedPageFilter/CopyWrittersFilter";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const videoOptioncard = [
  {
    cardIcon: <InfomarkIcon />,
    title: "Inquiring Videos",
    cardNo: "150",
  },
  {
    cardIcon: <RoundCheckIcon />,
    title: "Approved Videos",
    cardNo: "150",
  },
  {
    cardIcon: <WebsiteIcon />,
    title: "Website Only",
    cardNo: "150",
  },
  {
    cardIcon: <RoundTickIcon />,
    title: "Rejected Videos",
    cardNo: "150",
  },
];

const SearchCopywriterCard = (props) => {
  const [date, setDate] = useState("");
  const getDataFromChild = (date) => {
    // console.warn(date)
    setDate(date);
  };

  const [copywritersCardSubmissionData, setManagerCardSubmissionData] =
    useState({});

  const { mutate: mutating } = useMutation(getManagerCardSubmission);

  useEffect(() => {
    const managerId = {
      copyright_id: props.selectedId,
      from: date?.startDate,
      to: date?.endDate,
    };
    mutating(managerId, {
      onSuccess: (data) => {
        // console.warn(data, "managerId")
        setManagerCardSubmissionData(data);
      },
    });
  }, [date]);

  // const { data: submissionsListData } = useQuery(
  //   ["submissionsList", props.selectedId],
  //   async () =>
  //     submissionsList({
  //       copyright_id: props.selectedId,
  //     })
  // );

  const [openEditorsLargeModal, setOpenEditorsLargeModal] =
    React.useState(false);

  const handleOpenCommonModal = useCallback(() => {
    {
      props?.cardType === "info"
        ? setOpenEditorsLargeModal(true)
        : props?.cardType === "for_copywriter"
        ? setOpenCopywritterLargeModal(true)
        : props?.cardType === "for_qc"
        ? setOpenQcLargeModal(true)
        : props?.cardType === "for_manager"
        ? setOpenManagerLargeModal(true)
        : null;
    }
  }, []);

  const handleCloseEditorsLargeModal = useCallback(() => {
    setOpenEditorsLargeModal(false);
  }, []);

  const [openCopywritterLargeModal, setOpenCopywritterLargeModal] =
    React.useState(false);

  const handleCloseCopywritterLargeModal = useCallback(() => {
    setOpenCopywritterLargeModal(false);
  }, []);

  const [openQcLargeModal, setOpenQcLargeModal] = React.useState(false);

  const handleCloseQcLargeModal = useCallback(() => {
    setOpenQcLargeModal(false);
  }, []);

  const [openManagerLargeModal, setOpenManagerLargeModal] =
    React.useState(false);

  const handleCloseManagerLargeModal = useCallback(() => {
    setOpenManagerLargeModal(false);
  }, []);

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [innerTab, setInnerTab] = React.useState(0);

  const handleChange2 = (event, newValue) => {
    setInnerTab(newValue);
  };

  const [dinedTab, setdinedTab] = React.useState(0);

  const handleChange3 = (event, newValue) => {
    setdinedTab(newValue);
  };

  const [confimvdoTab, setConfimvdoTab] = React.useState(0);

  const handleChange4 = (event, newValue) => {
    setConfimvdoTab(newValue);
  };

  const [deniedvdoTab, setdeniedvdoTab] = React.useState(0);

  const handleChange5 = (event, newValue) => {
    setdeniedvdoTab(newValue);
  };

  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackOpen1, setSnackOpen1] = React.useState(false);

  const handleClick = () => {
    setSnackOpen(true);
  };

  const handleClick1 = () => {
    setSnackOpen1(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackOpen(false);
  };

  const handleClose1 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackOpen1(false);
  };
  const handleDataFromChild = (e) => {
    setPage(e);
    // Do something with the data received from the child component
  };
  const [page, setPage] = useState(1);
  const { data: VIDEOList, isLoading } = useQuery(
    ["VIDEOList", props.selectedId, page],

    async () => {
      return CopyWVIDEOMutation({ copyW_id: props.selectedId, page: page });
    }
  );

  const { data: submissionsListData } = useQuery(
    ["submissionsList", props.selectedId],
    async () =>
      submissionsList({
        copyright_id: props.selectedId,
      })
  );
  const [fetchTrigger, setFetchTrigger] = useState(Date.now());

  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };
  return (
    <>
      <Paper
        className={`${styles.srchCardPaper} ${styles.copywriterSrchCardPaper}`}
        onClick={() => handleOpenCommonModal()}
      >
        <Stack
          direction={"row"}
          flexWrap={"wrap"}
          className={styles.cardgrid}
          onClick={props.onClick}
        >
          {props?.avatar === "users/default.png" ? (
            <Avatar
              alt="Viral Snare"
              src={NOprofileImage}
              sx={{ width: 52, height: 52 }}
            />
          ) : (
            <Avatar
              alt="Viral Snare"
              src={concatHostAndImagePath(props?.avatar)}
              sx={{ width: 52, height: 52 }}
            />
          )}

          <Box className={styles.userDetails}>
            <List>
              <ListItem>
                <Typography variant="h3">{props?.name}</Typography>
              </ListItem>
              <ListItem>
                <Typography variant="caption">
                  Copywriter since:
                  {moment(props?.totaldata?.created_at).format("MMM Do YY")}
                </Typography>
              </ListItem>
              <ListItem className={styles.copywriterCardEmail}>
                <Typography variant="body1">
                  Email Address: <span>{props?.email}</span>
                </Typography>
              </ListItem>
              {/* {props?.assignAccount && (
                <ListItem>
                  <Typography variant="body1">
                    Assigned Accounts: <span>{props?.assignNo}</span>
                  </Typography>
                </ListItem>
              )} */}
              <ListItem>
                <Typography variant="body1">
                  Total Titled Videos:
                  <span>{props.totaldata.titled_videos}</span>
                </Typography>

                {/* <Typography variant="body1">
               Id: <span>{props.totaldata.id}</span>
                </Typography> */}
              </ListItem>
            </List>
            {props.cardType === "for_qc" ? (
              <Box className={styles.cardAlert}>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  flexWrap={"wrap"}
                  className={`${styles.textDenied} ${styles.stackStyled}`}
                >
                  <img
                    src={assest.iconDenied}
                    width={16}
                    height={16}
                    alt="icon"
                  />
                  <Typography variant="body1">
                    Denied Decisions: <span>450</span>
                  </Typography>
                </Stack>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  flexWrap={"wrap"}
                  className={`${styles.textConfirm} ${styles.stackStyled}`}
                >
                  <img
                    src={assest.iconConfirm}
                    width={16}
                    height={16}
                    alt="icon"
                  />
                  <Typography variant="body1">
                    Confirmed Decisions: <span>450</span>
                  </Typography>
                </Stack>
              </Box>
            ) : null}
          </Box>
          {props?.type === 1 ? (
            <Box className={`${styles.resultStatus} ${styles.success}`}>
              Active
            </Box>
          ) : props?.type === 0 ? (
            <Box className={`${styles.resultStatus} ${styles.inactive}`}>
              Inactive
            </Box>
          ) : null}
        </Stack>
        {props?.assignAccount && (
          <Stack
            direction={"row"}
            flexWrap={"wrap"}
            alignItems={"center"}
            className={styles.videoOption}
          >
            {videoOptioncard.map((option) => {
              return (
                <Paper elevation={0} className={styles.optionRowList}>
                  <figure>{option?.cardIcon}</figure>
                  <Box className={styles.queryRight}>
                    <Typography variant="body1">{option?.title}</Typography>
                    <Typography variant="caption">{option?.cardNo}</Typography>
                  </Box>
                </Paper>
              );
            })}
          </Stack>
        )}
      </Paper>

      {/* ================================================================= */}
      {/* ============ FOR COPYWRITERS PAGE MODAL DESIGN START ============ */}

      <EditorsLargeModal
        open={openCopywritterLargeModal}
        onClose={handleCloseCopywritterLargeModal}
        className={styles.singleCls}
      >
        <Stack
          direction={"row"}
          alignItems={"center"}
          flexWrap={"wrap"}
          className={styles.editorModalHeader}
        >
          <Stack
            direction={"row"}
            alignItems={"center"}
            flexWrap={"wrap"}
            className={styles.PfMediaBody}
          >
            {props?.fullitem?.avatar === "users/default.png" ? (
              <Avatar
                alt="Viral Snare"
                src={NOprofileImage}
                sx={{ width: 52, height: 52 }}
              />
            ) : (
              <Avatar
                // alt="Viral Snare"
                src={concatHostAndImagePath(props?.fullitem?.avatar)}
                sx={{ width: 52, height: 52 }}
              />
            )}
            <Box className={styles.profileMediaRight}>
              <Typography variant="body1">{props.fullitem.name}</Typography>
              <Typography variant="caption">
                {props.fullitem.role_id === 5 && "Copywriter"}
              </Typography>
            </Box>
          </Stack>
          <Stack className={`${styles.tabsFlex} ${styles.copywriterCalcWidth}`}>
            <Box className={styles.scrollTabs}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  icon={
                    <span>
                      <VideoIcon />
                    </span>
                  }
                  iconPosition="start"
                  label="Titled Videos"
                  {...a11yProps(0)}
                />
                <Tab
                  icon={
                    <span>
                      <AnalyticsIcon />
                    </span>
                  }
                  iconPosition="start"
                  label="Analytics"
                  {...a11yProps(1)}
                />
                <Tab
                  icon={
                    <span>
                      <ProfileIcon />
                    </span>
                  }
                  iconPosition="start"
                  label="Profile"
                  {...a11yProps(2)}
                />
              </Tabs>
            </Box>
          </Stack>
          <Button
            onClick={handleCloseCopywritterLargeModal}
            className="partnerCloseBtn"
          >
            <img src={assest.crossGray} width={13} height={13} alt="icon" />
          </Button>
        </Stack>
        <Box className={styles.tabPanelWrap}>
          <TabPanel value={value} index={0}>
            <Box className={styles.fluidSec}>
              <Paper
                className={`${styles.tablePaper} ${styles.tableEditorPaper}`}
              >
                {/* {VIDEOList?.data.length > 0 && ( */}
                {/* <ModaltableHeader
                    total=
                    allVideo={true}
                    searchType={false}
                    pendingBtn={true}
                    filterBtn={false}
                  /> */}
                {/* // )} */}
                {/* <CopyWrittersFilter

               
                  filterModalProps={{
                    handleTriggreFetch,
                    VIDEOList,
                    hideBottom: false,

                  
                  }}
                /> */}

                {isLoading ? (
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={isLoading}
                    onClick={handleClose}
                    className="loader"
                  >
                    {/* <FadeLoader color="#5C5C5C" /> */}
                    <div className="loader-wrapper">
                      <div className="loaderIcon">
                        <img
                          src={assest.logo_loader}
                          alt="img"
                          width={100}
                          height={100}
                        />
                      </div>
                    </div>
                  </Backdrop>
                ) : (
                  <CopywritersModalTable
                    selectedId={props.selectedId}
                    name={props.fullitem.name}
                    handleTriggreFetch={handleTriggreFetch}
                  />
                )}
              </Paper>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Stack
              direction={"row"}
              className={`${styles.editorBody} ${styles.modalEditorBody} ${styles.onlyForPxModal}`}
            >
              <Box className={styles.SecFilter}>
                <NotificationLeftFilter
                  filterType={"copywriter"}
                  getDataFromChild={getDataFromChild}
                />
              </Box>
              <Box className={`${styles.addEditor} ${styles.publishSummary}`}>
                <VideosummaryCard
                  videoTitle={"Video Titling Summary"}
                  countVideo={""}
                >
                  <List>
                    {/* {titlingSummaryLoop.map((item, index) => {
                        return (
                          <ListItem>
                            <Typography variant="body1">
                              {item?.listName}
                            </Typography>
                            <Typography variant="caption">
                              {item?.videoCount}
                            </Typography>
                          </ListItem>
                        );
                      })} */}

                    <ListItem>
                      <Typography variant="body1">Titled videos</Typography>
                      <Typography variant="caption">
                        {
                          copywritersCardSubmissionData?.data?.data
                            ?.video_titling.titled_video
                        }
                      </Typography>
                    </ListItem>

                    <ListItem>
                      <Typography variant="body1">Revised titles</Typography>
                      <Typography variant="caption">
                        {
                          copywritersCardSubmissionData?.data?.data
                            ?.video_titling.revised_title
                        }
                      </Typography>
                    </ListItem>

                    <ListItem>
                      <Typography variant="body1">Revision requests</Typography>
                      <Typography variant="caption">
                        {
                          copywritersCardSubmissionData?.data?.data
                            ?.video_titling.revesion_request
                        }
                      </Typography>
                    </ListItem>
                  </List>
                </VideosummaryCard>
              </Box>
            </Stack>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <EditorsCopywritersProfileTab
              wholedata={props}
              totaldata={props.totaldata}
              resettext={"copywriter"}
              accountSubmission={false}
              classProps={"true"}
              classPropsPartner={"true"}
            />
          </TabPanel>
        </Box>
      </EditorsLargeModal>
    </>
  );
};

export default SearchCopywriterCard;
